import axios from "axios";

export const getTransacciones = async () => {
    return axios.get('api/Transacciones/ConsultarTransaccionesAgrupadasPorLoteServicio')
}
